var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSettingsConfig = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "config",
    transform: "translate(-1026 -377)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 20,
    height: 20,
    transform: "translate(1026 377)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settings_suggest_FILL0_wght200_GRAD-25_opsz20",
    d: "M125.442,212.393l-.842-1.817-1.817-.842,1.817-.842.842-1.817.842,1.817,1.817.842-1.817.842Zm1.84,6.88-.659-1.4-1.4-.659,1.4-.659.659-1.4.659,1.4,1.4.659-1.4.659Zm-11.033,4.676-.23-1.889a7.441,7.441,0,0,1-.719-.344,3.2,3.2,0,0,1-.678-.467l-1.728.78-1.549-2.606L112.9,218.3a3.779,3.779,0,0,1-.09-.772,4.239,4.239,0,0,1,.09-.8l-1.552-1.123L112.9,213l1.728.78a2.848,2.848,0,0,1,.681-.491,4.687,4.687,0,0,1,.715-.32l.232-1.889h2.967l.23,1.889a4.357,4.357,0,0,1,.727.324,2.9,2.9,0,0,1,.669.487l1.725-.78,1.561,2.606-1.561,1.123a4.238,4.238,0,0,1,.09.8,3.779,3.779,0,0,1-.09.772l1.561,1.123-1.561,2.606-1.725-.78a3.233,3.233,0,0,1-.693.483,5.408,5.408,0,0,1-.7.328l-.232,1.889Zm1.481-4.132a2.307,2.307,0,1,0-1.627-.677A2.227,2.227,0,0,0,117.731,219.817Zm.006-.956a1.363,1.363,0,1,1,.948-.4A1.3,1.3,0,0,1,117.737,218.861Zm-.687,4.132h1.371l.21-1.63a3.584,3.584,0,0,0,1.112-.448,4.878,4.878,0,0,0,.934-.79l1.5.678.681-1.143-1.368-1a3.263,3.263,0,0,0,0-2.276l1.332-1.032-.645-1.107-1.5.654a5.389,5.389,0,0,0-.935-.759,4.446,4.446,0,0,0-1.11-.481l-.213-1.628h-1.372l-.212,1.628a4.557,4.557,0,0,0-1.114.481,4.856,4.856,0,0,0-.925.759l-1.5-.654-.645,1.107,1.332,1.032a2.776,2.776,0,0,0-.19,1.138,3.643,3.643,0,0,0,.19,1.138l-1.368,1,.681,1.143,1.51-.678a4.458,4.458,0,0,0,.928.79,3.694,3.694,0,0,0,1.108.448ZM117.734,217.513Z",
    transform: "translate(915.654 171.923)",
    fill: "#3953fb"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettingsConfig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settingsConfig.043632b0.svg";
export { ForwardRef as ReactComponent };